import React from "react";

const DeleteModal = ({ itemName, onClose, onDelete }) => {
  return (
    <div className="fixed inset-0 bg-[#000000cc] mb-0 bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-[10px] w-full max-w-md p-6">
        <div className="text-center">
          <svg
            className="mx-auto h-12 w-12 text-red-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
          <h3 className="mt-2 text-lg font-medium text-gray-900">
            Delete {itemName}
          </h3>
          <p className="mt-2 text-sm text-gray-500">
            Are you sure you want to delete this {itemName}? This action cannot be
            undone.
          </p>
          <div className="mt-4 flex justify-center space-x-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
            >
              Cancel
            </button>
            <button
              onClick={onDelete}
              className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
